import PortalLayout from "./PortalLayout";
import dashboard from '../../assets/Dashboard/students-dashboard.svg';
import { connect } from 'react-redux';
import { FaDownload } from "react-icons/fa";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import SubLoading from "../Loading/SubLoading";

const StudentDashboard = ({ profile, notices }) => {

    let match;
    if (notices && profile) {      
        match = notices.filter((notice) => {
            return notice.audience === 'All Students' || notice.audience === profile.programme || notice.audience === profile.division
        });  
        
        //console.log(id, notices, match)
    }
    return ( 
            <PortalLayout>
                <div className="section">
                    <div className="container">
                        <div className="dashboard center">
                            {
                                profile && <h4 className="is-size-5-touch is-size-4-desktop mt-6 mb-4 has-text-weight-semibold grey-text text-darken-3">Welcome {profile.forenames} {profile.surname} to your dashboard.</h4>
                            }
                            <div className="dashboard-illustration container">
                                <img src={dashboard} alt="Illustration" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        {
                            match ? (
                                <>
                                    <div className="topic-cont">
                                        <span className="is-size-6-touch is-size-5-desktop grey-text text-lighten-3">Notices</span>
                                    </div>
                                    {

                                        match.length !== 0 ? (
                                            //for match with len
                                            <>
                                             {
                                                match.slice(0, 7).map(notice => (
                                                    <div className="box mt-5" key={notice.id}>
                                                        <h6 className="subtitle has-text-weight-bold mb-2">{notice.topic}</h6>
                                                        <div className="divider"></div>
                                                        <div className="row">
                                                            <div className="col s12 m8 ">
                                                                <p className="block grey-text text-darken-2 mt-5">
                                                                    {notice.body}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {
                                                            notice.url  && (
                                                                <div className="control mb-4">
                                                                    <a 
                                                                        className="button is-success mt-3"
                                                                        href={notice.url}
                                                                        download
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <span className="icon">
                                                                            <FaDownload color="white"/>
                                                                        </span>
                                                                        <span className="white-text">{notice.filename}</span>
                                                                    </a>
                                                                </div>
                                                            )
                                                        }
                                                        <div className="mt-4">
                                                            <p className="grey-text light">{notice.date}</p>
                                                        </div>
                                                    </div>                                            
                                                ))
                                                }
                                            </>
                                        ) : (
                                            //no leg
                                            <div className="container pt-6">
                                                <p className="center has-text-weight-semibold grey-text text-darken-2 is-size-4 mb-4">No notifications available yet !</p>
                                            </div>
                                        )
                                    }
                                </>

                            ) : (
                               //LOADING
                               <SubLoading />
                            )
                        }
                    </div>
                </div>
            </PortalLayout>
        
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        profile: state.firebase.profile,
        id: state.firebase.auth.uid,
        notices: state.firestore.ordered.notices
    }   
}

export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "notices", orderBy: ['postDate', 'desc']
            }
    ])
)(StudentDashboard);

